import styled from "styled-components";
import { Widget } from "../../../../components/widget";
import { device } from "../../../../styles/media";

export const StyledWidget = styled(Widget)``;

export const Container = styled.form`
  @media ${device.laptop} {
    overflow: auto;
  }

  ${StyledWidget} {
    margin-bottom: 1em;
  }
  ${StyledWidget}:last-child {
    margin-bottom: 3em;
  }
`;
